import React from 'react';

import * as screens from 'services/routes/constants';
import pages from 'services/routes/pages';
import { retry } from 'services/utils';

import withResetState from 'services/appconfig/withResetState';

const ChatbotPageContainer = React.lazy(() =>
  retry(() => import('views/pages/chatbot'))
);
const DashboardContainer = React.lazy(() =>
  retry(() => import('views/pages/dashboard'))
);
const SummaryContainer = React.lazy(() =>
  retry(() => import('views/pages/category-analyze'))
);
const LandingPageAnalyzeContainer = React.lazy(() =>
  retry(() => import('views/pages/landing-page-analyze'))
);
const CVFlowContainer = React.lazy(() =>
  retry(() => import('views/pages/cv-flow'))
);
const CVAttributeContainer = React.lazy(() =>
  retry(() => import('views/pages/cv-attribute'))
);
const DetailAnalyzeContainer = React.lazy(() =>
  retry(() => import('views/pages/detail-analyze'))
);
const CostAllocationContainer = React.lazy(() =>
  retry(() => import('views/pages/cost-allocation'))
);
const MmmOptimizationResultsContainer = React.lazy(() =>
  retry(() =>
    import(
      'views/pages/mmm/optimization-results/MmmOptimizationResultsContainer'
    )
  )
);
const MmmAnalysisSettingsContainer = React.lazy(() =>
  retry(() =>
    import(
      'views/pages/mmm/analysis-settings/MmmAnalysisSettingsContainer'
    )
  )
);
const UserManagementContainer = React.lazy(() =>
  retry(() => import('views/pages/user-management'))
);
const AgencyManagementContainer = React.lazy(() =>
  retry(() => import('views/pages/agency-management'))
);
const PeriodAnalysisContainer = React.lazy(() =>
  retry(() => import('views/pages/period-analyze'))
);
const MediaTypeContainer = React.lazy(() =>
  retry(() => import('views/pages/ad-management/media'))
);
const AdGroup1Container = React.lazy(() =>
  retry(() => import('views/pages/ad-management/group1'))
);
const AdGroup2Container = React.lazy(() =>
  retry(() => import('views/pages/ad-management/group2'))
);
const ExternalServicesContainer = React.lazy(() =>
  retry(() => import('views/pages/external-services'))
);
const UserProfileContainer = React.lazy(() =>
  retry(() => import('views/pages/user-profile'))
);
const MediaSyncLoader = React.lazy(() =>
  retry(() => import('views/pages/media-sync-management'))
);
const ApiManagementContainer = React.lazy(() =>
  retry(() => import('views/pages/api-management'))
);
const SystemSettingCookiePersistenceContainer = React.lazy(() =>
  retry(() => import('views/pages/system-setting'))
);
const UsageStatusContainer = React.lazy(() =>
  retry(() => import('views/pages/usage-status'))
);
const ContactDemandManagementContainer = React.lazy(() =>
  retry(() => import('views/pages/contact/demand'))
);
const ContactManagementContainer = React.lazy(() =>
  retry(() => import('views/pages/contact'))
);
const PageManagementContainer = React.lazy(() =>
  retry(() => import('views/pages/page-management'))
);
const LineAddFriendSettingContainer = React.lazy(() =>
  retry(() => import('views/pages/line-add-friend-settings'))
);
const LpoLinkContainer = React.lazy(() =>
  retry(() => import('views/pages/lpo/link'))
);
const LpoPeriodContainer = React.lazy(() =>
  retry(() => import('views/pages/lpo/period'))
);

const LogPageAnalyzeContainer = React.lazy(() =>
  retry(() => import('views/pages/log/page-analyze'))
);
const LogPeriodAnalyzeContainer = React.lazy(() =>
  retry(() => import('views/pages/log/period-analyze'))
);
const ImpressionAdCostContainer = React.lazy(() =>
  retry(() => import('views/pages/impression-ad-cost'))
);
const LogRouteAnalyzeContainer = React.lazy(() =>
  retry(() => import('views/pages/log/route-analyze'))
);
const CapiSettingContainer = React.lazy(() =>
  retry(() => import('views/pages/capi-setting'))
);
const SCSettingContainer = React.lazy(() =>
  retry(() => import('views/pages/search-console-setting'))
);
const AcmIssueContainer = React.lazy(() =>
  retry(() => import('views/pages/acm-issue'))
);

// Adebify pages
const AdebifySettings = React.lazy(() =>
  retry(() => import('views/pages/adebify/settings'))
);
const AdebifyProductAnalysis = React.lazy(() =>
  retry(() => import('views/pages/adebify/product-analysis'))
);
const AdebifyLtvDetail = React.lazy(() =>
  retry(() => import('views/pages/adebify/ltv-detail'))
);
const AdebifyLtvCohort = React.lazy(() =>
  retry(() => import('views/pages/adebify/ltv-cohort'))
);
const AdebifyCustomReport = React.lazy(() =>
  retry(() => import('views/pages/adebify/custom-report'))
);
const routes = [
  {
    exact: true,
    component: withResetState(DashboardContainer),
    path: pages[screens.DASHBOARD].path,
    screenId: pages[screens.DASHBOARD].screenId,
  },
  {
    exact: true,
    component: withResetState(ChatbotPageContainer),
    path: pages[screens.CHATBOT].path,
    screenId: pages[screens.CHATBOT].screenId,
  },
  {
    exact: true,
    component: withResetState(SummaryContainer),
    path: pages[screens.CATEGORY_ANALYZE].path,
    screenId: pages[screens.CATEGORY_ANALYZE].screenId,
  },
  {
    exact: true,
    component: withResetState(LandingPageAnalyzeContainer),
    path: pages[screens.LANDING_PAGE_ANALYZE].path,
    screenId: pages[screens.LANDING_PAGE_ANALYZE].screenId,
  },
  {
    exact: true,
    component: withResetState(DetailAnalyzeContainer),
    path: pages[screens.DETAILS_ANALYSIS].path,
    screenId: pages[screens.DETAILS_ANALYSIS].screenId,
  },
  {
    exact: true,
    component: withResetState(CVFlowContainer),
    path: pages[screens.CV_FLOW].path,
    screenId: pages[screens.CV_FLOW].screenId,
  },
  {
    exact: true,
    component: withResetState(CVAttributeContainer),
    path: pages[screens.CV_ATTRIBUTE].path,
    screenId: pages[screens.CV_ATTRIBUTE].screenId,
  },
  {
    exact: true,
    component: withResetState(PeriodAnalysisContainer),
    path: pages[screens.COMPARE_PERIOD].path,
    screenId: pages[screens.COMPARE_PERIOD].screenId,
  },
  {
    exact: true,
    component: withResetState(CostAllocationContainer),
    path: pages[screens.COST_ALLOCATION].path,
    screenId: pages[screens.COST_ALLOCATION].screenId,
  },
  {
    exact: true,
    component: withResetState(UserManagementContainer),
    path: pages[screens.USER_MANAGEMENT].path,
    screenId: pages[screens.USER_MANAGEMENT].screenId,
  },
  {
    exact: true,
    component: withResetState(AgencyManagementContainer),
    path: pages[screens.AGENCY_MANAGEMENT].path,
    screenId: pages[screens.AGENCY_MANAGEMENT].screenId,
  },
  {
    exact: true,
    component: withResetState(MediaTypeContainer),
    path: pages[screens.AD_MANAGEMENT_MEDIA_TYPE].path,
    screenId: pages[screens.AD_MANAGEMENT_MEDIA_TYPE].screenId,
  },
  {
    exact: true,
    component: withResetState(AdGroup1Container),
    path: pages[screens.AD_MANAGEMENT_AD_GROUP_1].path,
    screenId: pages[screens.AD_MANAGEMENT_AD_GROUP_1].screenId,
  },
  {
    exact: true,
    component: withResetState(AdGroup2Container),
    path: pages[screens.AD_MANAGEMENT_AD_GROUP_2].path,
    screenId: pages[screens.AD_MANAGEMENT_AD_GROUP_2].screenId,
  },
  {
    exact: true,
    component: withResetState(ExternalServicesContainer),
    path: pages[screens.EXTERNAL_SERVICE_SETTINGS].path,
    screenId: pages[screens.EXTERNAL_SERVICE_SETTINGS].screenId,
  },
  {
    exact: true,
    component: withResetState(UserProfileContainer),
    path: pages[screens.USER_PROFILE].path,
    screenId: pages[screens.USER_PROFILE].screenId,
  },
  {
    exact: true,
    component: withResetState(MediaSyncLoader),
    path: pages[screens.MEDIA_SYNC_MANAGEMENT].path,
    screenId: pages[screens.MEDIA_SYNC_MANAGEMENT].screenId,
  },
  {
    exact: true,
    component: withResetState(ApiManagementContainer),
    path: pages[screens.API_MANAGEMENT].path,
    screenId: pages[screens.API_MANAGEMENT].screenId,
  },
  {
    exact: true,
    component: withResetState(UsageStatusContainer),
    path: pages[screens.USAGE_STATUS_SITE].path,
    screenId: pages[screens.USAGE_STATUS_SITE].screenId,
  },
  {
    exact: true,
    component: withResetState(ContactDemandManagementContainer),
    path: pages[screens.CONTACT_DEMAND_MANAGEMENT].path,
    screenId: pages[screens.CONTACT_DEMAND_MANAGEMENT].screenId,
  },
  {
    exact: true,
    component: withResetState(ContactManagementContainer),
    path: pages[screens.CONTACT_MANAGEMENT].path,
    screenId: pages[screens.CONTACT_MANAGEMENT].screenId,
  },
  {
    exact: true,
    component: withResetState(PageManagementContainer),
    path: pages[screens.MEASUREMENT_SITE_PAGE_MANAGEMENT].path,
    screenId: pages[screens.MEASUREMENT_SITE_PAGE_MANAGEMENT].screenId,
  },
  {
    exact: true,
    component: withResetState(LineAddFriendSettingContainer),
    path: pages[screens.LINE_ADD_FRIEND_SETTINGS].path,
    screenId: pages[screens.LINE_ADD_FRIEND_SETTINGS].screenId,
  },
  {
    exact: true,
    component: withResetState(ImpressionAdCostContainer),
    path: pages[screens.IMPRESSION_AD_COST].path,
    screenId: pages[screens.IMPRESSION_AD_COST].screenId,
  },
  {
    exact: true,
    component: withResetState(LogPageAnalyzeContainer),
    path: pages[screens.LOG_PAGE_ANALYZE].path,
    screenId: pages[screens.LOG_PAGE_ANALYZE].screenId,
  },
  {
    exact: true,
    component: withResetState(LogPeriodAnalyzeContainer),
    path: pages[screens.LOG_PERIOD_ANALYZE].path,
    screenId: pages[screens.LOG_PERIOD_ANALYZE].screenId,
  },
  {
    exact: true,
    component: withResetState(LogRouteAnalyzeContainer),
    path: pages[screens.LOG_ROUTE_ANALYZE].path,
    screenId: pages[screens.LOG_ROUTE_ANALYZE].screenId,
  },
  {
    exact: true,
    component: withResetState(CapiSettingContainer),
    path: pages[screens.CAPI_SETTING].path,
    screenId: pages[screens.CAPI_SETTING].screenId,
  },
  {
    exact: true,
    component: withResetState(SCSettingContainer),
    path: pages[screens.SEARCH_CONSOLE_SETTING].path,
    screenId: pages[screens.SEARCH_CONSOLE_SETTING].screenId,
  },
  {
    exact: true,
    component: withResetState(LpoLinkContainer),
    path: pages[screens.LPO_LINK].path,
    screenId: pages[screens.LPO_LINK].screenId,
  },
  {
    exact: true,
    component: withResetState(LpoPeriodContainer),
    path: pages[screens.LPO_PERIOD].path,
    screenId: pages[screens.LPO_PERIOD].screenId,
  },
  {
    exact: true,
    component: withResetState(MmmAnalysisSettingsContainer),
    path: pages[screens.MMM_ANALYSIS_SETTINGS].path,
    screenId: pages[screens.MMM_ANALYSIS_SETTINGS].screenId,
  },
  {
    exact: true,
    component: withResetState(MmmOptimizationResultsContainer),
    path: `${pages[screens.MMM_OPTIMIZATION_RESULTS].path}/list`,
    screenId: pages[screens.MMM_OPTIMIZATION_RESULTS].screenId,
  },
  {
    exact: true,
    component: withResetState(MmmOptimizationResultsContainer),
    path: `${pages[screens.MMM_OPTIMIZATION_RESULTS].path}/:resultId`,
    screenId: pages[screens.MMM_OPTIMIZATION_RESULTS].screenId,
  },
  {
    exact: true,
    component: withResetState(MmmOptimizationResultsContainer),
    path: pages[screens.MMM_OPTIMIZATION_RESULTS].path,
    screenId: pages[screens.MMM_OPTIMIZATION_RESULTS].screenId,
  },
  {
    exact: true,
    component: withResetState(AcmIssueContainer),
    path: `${pages[screens.ACM_ISSUE].path}/:id`,
    screenId: pages[screens.ACM_ISSUE].screenId,
  },
  // Adebify routes
  {
    exact: true,
    component: withResetState(AdebifySettings),
    path: pages[screens.ADEBIFY_SETTINGS].path,
    screenId: pages[screens.ADEBIFY_SETTINGS].screenId,
  },
  {
    exact: true,
    component: withResetState(AdebifyProductAnalysis),
    path: pages[screens.ADEBIFY_PRODUCT_ANALYSIS].path,
    screenId: pages[screens.ADEBIFY_PRODUCT_ANALYSIS].screenId,
  },
  {
    exact: true,
    component: withResetState(AdebifyLtvDetail),
    path: pages[screens.ADEBIFY_LTV_DETAIL].path,
    screenId: pages[screens.ADEBIFY_LTV_DETAIL].screenId,
  },
  {
    exact: true,
    component: withResetState(AdebifyLtvCohort),
    path: pages[screens.ADEBIFY_LTV_COHORT].path,
    screenId: pages[screens.ADEBIFY_LTV_COHORT].screenId,
  },
  {
    exact: true,
    component: withResetState(AdebifyCustomReport),
    path: pages[screens.ADEBIFY_CUSTOM_REPORT].path,
    screenId: pages[screens.ADEBIFY_CUSTOM_REPORT].screenId,
  },
];

export default routes;
